import React from 'react';

export const useDialogControl = () => {
  const [dialogName, setDialogName] = React.useState('');
  const onCloseDialog = () => {
    setDialogName('');
  };
  return { setDialogName, dialogName, onCloseDialog };
};
